<template>
    <div class="body-bg">
        <page-navigate :blankType="true"></page-navigate>
        <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.requestLang'), $t('common.type')]">
            <section class="section1">
                <!-- {{ $i18n.locale }} -->
                <img class="logo_banner" :src="logoList[$i18n.locale]" alt="" />
                <h1 class="cn-font-family-title" v-html="$t('referral.推荐好友加入')">

                </h1>
                <h1 class="cn-font-family-title largerWord" v-html="$t('referral.赢取巴塞罗那VIP之旅')">
                </h1>
                <h1 class="en-font-family-title"></h1>
                <div class="title-box">
                    <!-- <div class="line-left"></div> -->
                    <span>{{ $t("referral.成为EBC推荐官") }}</span>
                    <!-- <div class="line-right"></div> -->
                </div>
                <a :href="signupUrl" target="_blank" class="btn">
                    {{ $t("referral.立即参与") }}
                </a>
            </section>
            <section class="section2">
                <h2 class="cn-font-family-title">{{ $t("referral.专属奖励等你拿") }}</h2>
                <h3>{{ $t("referral.您将获得以下奖励") }}</h3>

                <div class="vectors">
                    <span class="iconfont icon-Vector red"></span>
                    <span class="iconfont icon-Vector blue"></span>
                </div>
                <div class="content-box">
                    <div class="item">
                        <img src="../assets/image/win/section2-boxImg.png" alt="" />
                        <div class="word">{{ $t("referral.西班牙巴塞罗那之旅") }}</div>
                        <div class="shadow">{{ $t("referral.西班牙巴塞罗那之旅") }}</div>
                    </div>
                    <div class="item">
                        <img src="../assets/image/win/section2-boxImg2.png" alt="" />
                        <div class="word">
                            {{ $t("referral.巴塞罗那足球俱乐部主场比赛VIP门票") }}
                        </div>
                        <div class="shadow">
                            {{ $t("referral.巴塞罗那足球俱乐部主场比赛VIP门票") }}
                        </div>
                    </div>
                    <div class="item">
                        <img src="../assets/image/win/section2-boxImg3.png" alt="" />
                        <div class="word">{{ $t("referral.巴塞罗那足球俱乐部专属晚宴") }}</div>
                        <div class="shadow">{{ $t("referral.巴塞罗那足球俱乐部专属晚宴") }}</div>
                    </div>
                    <div class="item">
                        <img src="../assets/image/win/section2-boxImg4.png" alt="" />
                        <div class="word">
                            {{ $t("referral.往返机票酒店住宿当地接送导服务") }}
                        </div>
                        <div class="shadow">
                            {{ $t("referral.往返机票酒店住宿当地接送导服务") }}
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="left"></div>
                    <div class="right"></div>
                </div>
            </section>
            <section class="section3">
                <h2 class="cn-font-family-title">{{ $t("referral.如何赢取大奖") }}</h2>
                <div class="vectors">
                    <span class="iconfont icon-Vector red"></span>
                    <span class="iconfont icon-Vector blue"></span>
                </div>
                <!-- <p class="section-intro">{{ $t("referral.立即推荐") }}</p> -->
                <div class="step-box">
                    <div class="step-item">
                        <img class="step-img" src="../assets/image/win/inner/step1.png" alt="" />
                        <p class="p1">{{ $t("referral.登录EBC用户中心") }}</p>
                    </div>
                    <img class="step-right" src="../assets/image/win/section3_right.png" alt="" />
                    <div class="step-item">
                        <img class="step-img" src="../assets/image/win/inner/step2.png" alt="" />
                        <p class="p1">{{ $t("referral.进入“大赛推荐官”活动页面") }}</p>
                    </div>
                    <img class="step-right" src="../assets/image/win/section3_right.png" alt="" />
                    <div class="step-item">
                        <img class="step-img" src="../assets/image/win/inner/step3.png" alt="" />
                        <p class="p1">{{ $t("referral.生成您的邀请链接或二维码") }}</p>
                    </div>
                    <img class="step-right" src="../assets/image/win/section3_right.png" alt="" />
                    <div class="step-item">
                        <img class="step-img" src="../assets/image/win/inner/step4.png" alt="" />
                        <p class="p1">{{ $t("referral.成功推荐66人") }}</p>
                    </div>
                </div>
            </section>
            <div class="section3-tip">
                <img src="../assets/image/win/section3-tip-left.png" alt="">
                {{ $t("referral.成功推荐奖励") }}
                <img src="../assets/image/win/section3-tip-right.png" alt="">
            </div>
            <section class="section4">
                <!-- <video muted="muted" autoplay="autoplay" loop="loop" playsinline poster="@/assets/image/win/FCB-3.jpg"
                    class="section4-video pc">
                    <source src="@/assets/videos/FCB_1 1.mp4" type="video/mp4" />
                </video> -->
                <div class="section4-pic">
                    <img src="../assets/image/win/inner/image-section4.png" alt="">
                </div>
                <h2 class="cn-font-family-title">{{ $t("referral.你还在等什么") }}</h2>
                <p class="section-intro" v-html="$t('referral.EBC为交易者捉供更低点差')"></p>
                <div class="vectors">
                    <span class="iconfont icon-Vector red"></span>
                    <span class="iconfont icon-Vector blue"></span>
                </div>
                <a :href="signupUrl" target="_blank" class="btn">
                    {{ $t("referral.立即参与") }}
                </a>

            </section>
            <section class="section5">
                <div class="tip-title">
                    <div class="left"></div>
                    <div class="right"></div>
                </div>
                <div class="tip-box">
                    <!-- <div class="red-to-blue-line"></div> -->
                    <div class="tips">
                        <div class="tip-item">
                            <p class="p1">{{ $t('referral.活动时间') }}</p>
                            <p class="p2">
                                {{ $t('referral.2025年2月22日') }}
                            </p>
                        </div>
                        <div class="tip-item">
                            <p class="p1">{{ $t('referral.活动规则') }}</p>
                            <p class="p2" v-for="item in $t('referral.ruleList')">{{ item }}</p>
                        </div>
                    </div>
                    <!-- <div class="red-to-blue-line"></div> -->
                </div>
            </section>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex';
import 'swiper/css/swiper.css'
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            logoList: {
                zh: require('@/assets/image/win/logo.svg'),
                ct: require('@/assets/image/win/logo_zh.svg'),
                th: require('@/assets/image/win/logo_th.svg'),
                vn: require('@/assets/image/win/logo_vi.svg'),
                en: require('@/assets/image/win/logo_en.svg'),
                ja: require('@/assets/image/win/logo_jp.svg'),
                ko: require('@/assets/image/win/logo_kr.svg'),
            },
            swiperSection4: {
                slidesPerView: 1.9,
                autoplay: true,
                loop: true,
                centeredSlides: true,
                spaceBetween: 80,
            },
            // signupUrl: "https://client.myebc.co/signup/",
        }
    },
    methods: {
        requireLogo(src) {
            return require(src);
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    }
}
</script>
<style>
.vipWord {
    color: #FFED95;
}
</style>
<style scoped>
.section4 .swiper-container {
    overflow: visible;
}

.body-bg {
    background-color: #13132C;
    background-image: url("../assets/image/win/bg.png");
    background-size: 100% auto;
    background-repeat: repeat-y;
}

.section1 {
    position: relative;
    padding: 160rem 120rem 0;
    ;
    height: 900rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("../assets/image/win/inner/bg.png?v=1.0.1");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.logo_banner {
    width: auto;
    height: 72rem;
}

.btn {
    margin-top: 48rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 12rem 60rem;
    min-width: 400rem;
    border-radius: 8rem;
    background: #a52933;
    color: #fff;
    font-size: 18rem;
    font-weight: 500;
    line-height: 1em;
    opacity: .9;
    animation: scaleAnimation 2s infinite;
}

@keyframes scaleAnimation {
    0% {
        transform: scale(1);
        /* 初始状态，原始大小 */
    }

    37.5% {
        /* 在前0.75秒内放大到1.1倍 */
        transform: scale(1.1);
    }

    50% {
        /* 静止0.25秒 */
        transform: scale(1.1);
    }

    87.5% {
        /* 接下来的0.75秒内缩小回原始大小 */
        transform: scale(1);
    }

    100% {
        /* 再静止0.25秒 */
        transform: scale(1);
    }
}

.btn:hover {
    color: #fff;
}

section h1,
h2 {
    font-weight: 900 !important;
}

.section1 h1 {
    margin-top: 50rem;
    color: #fff;
    text-align: center;
    text-shadow: 0px 3.641px 3.641px rgba(0, 0, 0, 0.45);
    font-size: 75rem;
    line-height: normal;
}

.section1 .largerWord {
    font-size: 85rem;
    margin-top: 0;
}

.en .section1 h1 {
    font-size: 48rem;
}

.title-box {
    margin-top: -20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7rem;
    color: #fff;
    text-align: center;
    font-size: 17rem;
    font-weight: 400;
    line-height: normal;
    opacity: .7;
}

.line-left {
    height: 1px;
    width: 100rem;
    background: linear-gradient(to left,
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0));
}

.ar .line-left {
    height: 1px;
    width: 100rem;
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0));
}

.line-right {
    height: 1px;
    width: 100rem;
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0));
}

.ar .line-right {
    height: 1px;
    width: 100rem;
    background: linear-gradient(to left,
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0));
}

.section5 {
    padding: 80rem 370rem 40rem;
}

.section3 {
    padding: 100rem 370rem 120rem;
}

.section4 h2,
.section3 h2 {
    color: #fff;
    text-align: center;
    font-size: 40rem;
    font-weight: 700;
    line-height: normal;
}

.section4 .btn {
    margin-top: 10rem;
}

.section2 {
    margin: 0 230rem;
    padding: 72rem 100rem;
    border-radius: 16rem;
    background: #fff;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.section2 .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
}

.section2 .footer div {
    flex: 1;
    height: 12rem;
}

.section2 .footer .left {
    background: #114291;
}

.section2 .footer .right {
    background: #A52933;
}

.section2 h2 {
    color: #232222;
    font-size: 40rem;
    font-weight: 600;
}

.section2 h3 {
    color: #6A6967;
    font-size: 30rem;
    font-weight: 400;
    margin-top: 20rem;
}

.section2 .content-box {
    display: flex;
    justify-content: space-between;
    gap: 15rem;
}

.section2 .content-box .item {
    flex: 1;
    border-radius: 8rem;
    box-shadow: 5px 5px 10px rgba(200, 200, 200, 0.8);
    overflow: hidden;
    position: relative
}

.section2 .content-box .shadow {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.60);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    color: #FFF;
    font-size: 20rem;
    font-weight: 700;
    padding: 0 15rem;
}

.section2 .content-box .item:hover .shadow {
    z-index: 10;
}

.section2 .content-box .item:hover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.section2 .content-box .item:hover .word {
    display: none;
}

.section2 .content-box .item img {
    width: 100%;
}

.section2 .content-box .item .word {
    color: #000;
    text-align: center;
    font-family: "Source Han Sans CN";
    font-size: 14rem;
    font-weight: 400;
    height: 60rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.vectors {
    display: flex;
    justify-content: center;
    gap: 10rem;
    margin: 26rem auto;
}

.vectors .icon-Vector {
    font-size: 32rem;
}

.red {
    color: #a52933;
}

.blue {
    color: #114291;
}

.section3-tip {
    margin: -40rem auto 100rem;
    width: 1000rem;
    height: 60rem;
    background: url('../assets/image/win/pc-section3-tipBg.png');
    background-size: 100% 100%;
    color: #fff;
    font-size: 14rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13rem;
}

.section-intro {
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 1000rem;
    margin: 0 auto;
}

.rule-box {
    display: flex;
    justify-content: space-between;
    margin-top: 100rem;
    gap: 60rem;
    padding: 0 40rem;
}

.rules {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
}

.rules .p1 {
    color: #dab988;
    font-size: 28rem;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 16rem;
}

.rules .p2 {
    color: #fff;
    font-size: 24rem;
    font-weight: 400;
    line-height: normal;
}

.rule-img {
    flex-shrink: 0;
    width: 396rem;
    height: 224rem;
}

.step-box {
    position: relative;
    margin-top: 70rem;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
}

.step-item {
    width: 33.3%;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.step-right {
    height: 90rem;
    align-self: center;
}

.ar .step-right {
    transform: rotate(180deg);
}

.step-img {
    width: 175rem;
    height: 113rem;
}

.step-item .p1 {
    margin-top: 20rem;
    color: #fff;
    text-align: center;
    font-size: 20rem;
    font-weight: 500;
    line-height: normal;
}

.section4 {
    padding: 320rem 100rem 120rem;
    position: relative;
    overflow: hidden;
    text-align: center;
}

.section4-video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: -1;
}

.section4 .section-intro {
    color: #E6DDCF;
    font-size: 18rem;
    font-weight: 400;
    margin-top: 20rem;
}

.section4-pic {
    width: calc(100% - 200rem);
    border-top-left-radius: 40rem;
    border-top-right-radius: 40rem;
    overflow: hidden;
    z-index: 0;
    position: absolute;
    top: 0;
    /* z-index:-1; */
}

.section4-pic img {
    width: 100%;
}

.section4-content {
    display: flex;
    justify-content: center;
    gap: 21rem;
    margin-top: 60rem;
}

.section4-item {
    position: relative;
    display: flex;
    width: 380rem;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    background: rgba(0, 0, 0, 0.49);
    transition: all 0.3s;
}

.red-to-blue {
    border-left: 1px solid #a52933;
    border-right: 1px solid #114291;
}

.red-to-blue-line {
    width: 100%;
    height: 1px;
    min-height: 1px;
    background: linear-gradient(to right, #a52933, #114291);
    flex-shrink: 0;
}

.section4-item:hover {
    transform: scale(1.05);
}

.section4-item-img {
    width: 380rem;
    height: 254rem;
}

.section4-item h4 {
    padding: 0 16rem;
    color: rgba(255, 255, 255, 0.9);
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 18rem;
}

.section4-item p {
    padding: 0 16rem;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    margin-top: 20rem;
    margin-bottom: 28rem;
    /* line-height: 1em; */
    flex: 1;
}

.tip-title {
    display: flex;
}

.tip-title .left {
    width: 740rem;
    height: 12rem;
    background: linear-gradient(to left, #114291, rgba(17, 66, 145, .3))
}

.tip-title .right {
    width: 740rem;
    height: 12rem;
    background: linear-gradient(to right, rgb(165, 41, 51), rgba(165, 41, 51, .3));
}

.tip-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tips {
    padding: 100rem 56rem;
}

.tip-item+.tip-item {
    margin-top: 20rem;
}

.tip-item .p1 {
    color: rgba(255, 255, 255);
    font-size: 16rem;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 6rem;
    text-align: center;
}

.tip-item .p2 {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14rem;
    font-weight: 350;
    line-height: normal;
    text-align: center;
    margin-top: 10rem;
}

@media (max-width: 996px) {
    body {
        background-color: #13132C;
        background-image: url("../assets/image/win/bg_m.png?v=1.0.1");
        background-size: 100% auto;
        background-repeat: repeat-y;
    }

    .title-box {
        font-size: 22rem;
        gap: 20rem;
        width: 70vw;
    }

    .section1 {
        padding: calc(80px + 120rem) 40rem 120rem;
        height: unset;
        min-height: 803rem;
        background: url("../assets/image/win/inner/bg_m.png?v=1.0.1");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .section1 h1 {
        font-size: 60rem;
    }

    .section1 .largerWord {
        font-size: 65rem;
        font-weight: 700;
    }

    .btn {
        padding: 24rem 80rem;
        font-size: 28rem;
    }

    .section2,
    .section3,
    .section5 {
        padding: 120rem 40rem;
    }

    .section4 {
        padding: 220rem 0;
    }

    .section-intro {
        font-size: 28rem;
    }

    .section4 .section-intro,
    .section4 h2 {
        padding: 0 40rem;
    }

    .section2 {
        margin: 0 30rem;
    }

    .section2 .content-box {
        flex-direction: column;
        gap: 25rem;
    }

    .section2 .content-box .item img {
        height: 310rem;
    }

    .section2 .content-box .item {
        flex: none;
        height: 410rem;
        display: flex;
        flex-direction: column;
    }

    .section2 .content-box .word {
        font-size: 22rem !important;
        font-weight: 400;
        flex: 1;
    }

    .section2 h3 {
        margin-top: 40rem;
    }

    .section3-tip {
        margin: -70rem 0 80rem;
        width: 100%;
        height: auto;
        padding: 30rem 0;
        background: url('../assets/image/win/m-section3-tipBg.png');
        background-size: 100% 100%;
        color: #fff;
        font-size: 26rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 40rem;
        gap: 5rem;
        text-align: center;
    }

    .section3-tip img {
        width: 60rem;
    }

    .rule-box {
        flex-direction: column;
        align-items: center;
    }

    .rule-img {
        order: 1;
        width: 387rem;
        height: 189rem;
    }

    .rules {
        order: 2;
    }

    .rules .p1 {
        text-align: center;
        font-size: 40rem;
    }

    .rules .p2 {
        text-align: center;
        font-size: 32rem;
    }

    .step-box {
        display: grid;
        grid-template-columns: 1fr 80rem 1fr;
        grid-template-rows: 1fr 120rem 1fr;
    }

    .step-item {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .step-item:nth-of-type(3) {
        grid-column: 3;
        grid-row: 3;
    }

    .step-item:nth-of-type(4) {
        grid-column: 1;
        grid-row: 3;
    }

    .step-right:nth-of-type(1) {
        transform: rotate(0deg) translate(10rem, -20rem);
    }

    .step-right:nth-of-type(2) {
        grid-column: 3;
        grid-row: 2;
        transform: rotate(90deg) translate(-20rem, -115rem);
    }

    .step-right:nth-of-type(3) {
        grid-column: 2;
        grid-row: 3;
        transform: rotate(180deg) translate(-10rem, 20rem);
    }

    .ar .step-right,
    .step-right {
        transform: rotate(90deg);
    }

    .step-img {
        width: unset;
        height: 110rem;
    }

    .step-item .p1 {
        font-size: 26rem;
        font-weight: 400;
    }

    .section4-intro {
        margin-top: 70rem;
        font-weight: 400;
        line-height: 49rem;
        font-size: 24rem;
        padding: 0 25rem;
    }

    .section4 {
        height: auto;
        padding-bottom: 80rem;
        margin-top: 0;
    }

    .section4-pic {
        width: 100%;
        height: 300rem;
    }

    .section4-pic img {
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    .section4-item {
        flex-shrink: 0;
    }

    .section4-item:hover {
        transform: scale(1);
    }

    .section4-content {
        display: none;
        /* width: 700rem;
    margin-left: 25rem;
    margin-right: 25rem;
    overflow-x: auto;
    justify-content: flex-start; */
    }

    .swiper-slide-active .section4-item {
        transform: scale(1.3);
    }

    .section4-content-m {
        position: relative;
        padding-top: 180rem;
        padding-bottom: 180rem;
        margin-top: 50rem;
    }

    .section4-item-img {
        width: 100%;
        height: auto;
    }

    .section4-video {
        width: auto;
        height: 100%;
        bottom: 0;
        top: unset;
        z-index: 0;
    }

    .section4-item h4 {
        font-size: 24rem;
        line-height: normal;
    }

    .section4-item p {
        font-size: 20rem;
        line-height: normal;
    }

    .logo_banner {
        /* width: 499rem; */
        /* height: 81rem; */
    }

    .tips {
        padding: 48rem 50rem;
    }

    .tip-item+.tip-item {
        margin-top: 60rem;
    }

    .tip-title {
        display: flex;
    }

    .tip-title .left {
        width: 344rem;
        height: 12rem;
        background: linear-gradient(to left, #114291, rgba(17, 66, 145, .3))
    }

    .tip-title .right {
        width: 344rem;
        height: 12rem;
        background: linear-gradient(to right, rgb(165, 41, 51), rgba(165, 41, 51, .3));
    }

    .tip-item .p1 {
        font-size: 32rem;
        margin-bottom: 40rem;
        text-align: center;
        font-weight: 400;
    }

    .tip-item .p2 {
        font-size: 28rem;
        text-align: center;
        margin-top: 9rem;
    }

    .line-left {
        width: 80rem;
    }

    .ar .line-left {
        width: 80rem;
    }

    .line-right {
        width: 80rem;
    }

    .ar .line-right {
        width: 80rem;
    }
}
</style>